export const API_CONFIG = {
  TIMEOUT: 30000,
  BASE_URL:
  // window.location.hostname === 'localhost'
    window.location.port === '5173'
      ? '/api'
      : import.meta.env.VITE_API_BASE_URL || '/api',
} as const;

export const ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/authenticate',
    REFRESH: '/auth/refresh-token',
    ME: '/auth/me',
    CHANGE_PASSWORD: '/auth/change-password',
    MICROSOFT: '/auth/authenticate/microsoft',
  },

  USERS: {
    BASE: '/user',
    LIST: '/user',
    BY_ID: (id: string) => `/user/${id}`,
    BY_LOGIN: (login: string) => `/user/login/${login}`,
    ACTIVATE: (id: string) => `/user/${id}/activate`,
    DEACTIVATE: (id: string) => `/user/${id}/deactivate`,
    BULK: '/user/bulk',
    REPORT_PERMISSIONS: '/user/report-permissions',
  },

  PROFILE: {
    CURRENT: '/user/profile',
  },

  ROLES: {
    BASE: '/role',
    LIST: '/role',
    BY_ID: (id: string) => `/role/${id}`,
    DEFAULT: '/role/default',
    EXPORT: '/role/export',
  },

  COMPANIES: {
    BASE: '/company',
    LIST: '/company',
    BY_ID: (id: string) => `/company/${id}`,
  },

  THEMES: {
    CURRENT: '/theme/current',
    UPLOAD_PREVIEW: '/theme/upload-preview',
    APPLY: '/theme/apply',
    DOWNLOAD: '/theme/download',
  },

  APPLICATION: {
    BASE: '/application',
    SEARCH: '/application',
    DETAIL: (id: string) => `/application/${id}`,
    PERMITTED: '/application/permitted',
  },

  REPORT: {
    PERMITTED: '/report/permitted',
  },

  EMBEDDED_REPORT: {
    BASE: '/EmbeddedReport',
  },

  COMMON: {
    DROPDOWNS: '/Common/dropdowns',
    DEPARTMENTS: '/Common/departments',
  },

  REPORT_FILTER: {
    BASE: '/ReportFilter',
    LIST: '/ReportFilter',
    BY_ID: (id: string) => `/ReportFilter/${id}`,
    HISTORY: (id: string) => `/ReportFilter/${id}/history`,
    BULK: '/ReportFilter/bulk',
    BULK_DELETE: '/ReportFilter/bulk-delete',
    BULK_INACTIVE: '/ReportFilter/bulk-inactive',
  },

  DEPARTMENTS: {
    BASE: '/Department',
    LIST: '/Department',
    BY_ID: (id: string) => `/Department/${id}`,
  },

  LOG_ACTION: {
    LIST: '/LogAction',
  },

  CHATBOT: {
    BASE: '/Chatbot',
    LIST: '/Chatbot',
    BY_ID: (id: string) => `/Chatbot/${id}`,
    MY: '/Chatbot/my',
    SORT: '/Chatbot/sort',
    USERS: '/Chatbot/users',
    ASSIGN_USERS: (id: string) => `/Chatbot/${id}/users`,
    REMOVE_USER: (id: string, userId: string) =>
      `/Chatbot/${id}/users/${userId}`,
  },
} as const;

export default ENDPOINTS;
